import { styled } from '@mui/material/styles'
import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type FooterStylesType = {
  footer: SxProps
  footerContent: SxProps
  rowIcons: SxProps
  rowWrapperIcons: SxProps
  linkIcon: SxProps
  rowLinks: SxProps
  link: SxProps
  footerBorder: SxProps
}

export const footerStyles: FooterStylesType = {
  footer: {
    width: '100%',
    backgroundColor: theme.colors.white01,
    borderTop: '1px solid #B6B7BB',
    boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',
    zIndex: 940
  },

  footerContent: {
    padding: theme.spacing('8px', '120px'),

    '@media (min-width:768px) and (max-width: 1439px)': {
      padding: theme.spacing('8px', '48px')
    },

    '@media (max-width:767px)': {
      padding: theme.spacing('8px', '32px')
    }
  },

  rowIcons: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing('8px', '0px'),
    boxSizing: 'content-box',
    marginBottom: 1.5,

    '@media (max-width:767px)': {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },

  rowWrapperIcons: {
    '@media (max-width:767px)': {
      marginTop: 2
    }
  },

  rowLinks: {
    padding: theme.spacing('8px', '0px'),
    boxSizing: 'content-box'
  },

  linkIcon: {
    marginLeft: 1.5,
    height: 32,

    '&:first-child': {
      marginLeft: 0
    },

    '& .MuiSvgIcon-root': {
      fontSize: 32
    },

    '@media (max-width:767px)': {
      marginRight: 1.5,
      marginLeft: 0,

      '&:last-child': {
        marginRight: 0
      }
    }
  },

  link: {
    color: '#363942',
    fontFamily: theme.fonts.interFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px'
  },

  footerBorder: {
    height: 12,
    background: `linear-gradient(90deg,  ${theme.corporate.primaryColor} 0%, #2134F1 50%,  #F81BBD 95%)`
  }
}

export const SpanCopyright = styled('span')(() => ({
  color: '#363942',
  fontFamily: theme.fonts.interFont,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  marginRight: theme.spacing(0.5)
}))

export const SpanSeparator = styled('span')(() => ({
  color: '#363942',
  fontFamily: theme.fonts.interFont,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  margin: theme.spacing(0, 0.85)
}))
